import api from './api';
import { CitySnapshot } from '../models';
import { getBackVersion } from '../config';

const getCities = (): Promise<CitySnapshot[]> => {
    return api.request<CitySnapshot[]>({
        method: 'GET',
        url: `${getBackVersion()}/cities`,
    });
};

export default { getCities };
